module.exports = __webpack_public_path__ + "img/object_utilgn.f20abec6.svg";